import { gql, TypedDocumentNode } from "@apollo/client";

import { AuthorizationScheme, MutationAccountUpdateAuthorizationSchemeArgs } from "types/generated";

type GetAuthorizationSchemeData = {
  authorizationScheme: AuthorizationScheme;
};

export const GET_AUTHORIZATION_SCHEME: TypedDocumentNode<GetAuthorizationSchemeData> = gql`
  query GetAuthorizationScheme {
    authorizationScheme
  }
`;

type UpdateAccountAuthSchemeData = {
  accountUpdateAuthorizationScheme: AuthorizationScheme;
};

export const UPDATE_ACCOUNT_AUTH_SCHEME: TypedDocumentNode<
  UpdateAccountAuthSchemeData,
  MutationAccountUpdateAuthorizationSchemeArgs
> = gql`
  mutation updateAccountAuthScheme($schema: AuthorizationScheme!) {
    accountUpdateAuthorizationScheme(schema: $schema)
  }
`;
